import React, { useRef, useState } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { fetchdata, fetchreportdata } from './../reduxactions/fundmanagersactions/OrganizationsReportsActions';
import { Dialog } from 'primereact/dialog';
import { DropdownChangeEvent } from 'primereact/dropdown';
import { Dropdown } from 'primereact/dropdown';
import { useNavigate } from 'react-router-dom';
import { GFNButton } from '../ui';
import { Panel } from 'primereact/panel';

export const FundOrganizationsReports = () => {
  interface NeedData {
    year: any; // Change the type accordingly
  }
  const uid = window.sessionStorage.getItem('uid');
  const [globalFilter, setGlobalFilter] = useState('')
  const data = useSelector((state: RootState) => state.fmorgreports.data);

  const dispatch = useDispatch();

  //To get data
  const fetchDataAsync = async () => {
    try {
      await dispatch(fetchdata(uid) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  // To get data
  useEffectOnce(() => {
    fetchDataAsync();
  }, [dispatch]);
  //   dialog box data
  const [acceptfield, setfield] = useState(false);
  const cancelfield = () => {
    setfield(false);
  }
  //To assign data 
  const [assignData, setassignData] = useState({
    id: '',
    orgID: null
  });
  const viewupload = (rowData: any) => {
    setassignData({
      id: rowData.id,
      orgID: rowData.orgID,
    });

    setfield(true);
    fundreportdata()
  };

  const fundreportdata = async () => {
    try {
      await dispatch(fetchreportdata(uid) as any);
    } catch (error) {
      console.error('Error fetching data', error)
    }
  }
  const reportdata = useSelector((state: RootState) => state.fmorgreports.reportdata);
  console.log("reportdata:", reportdata)
  const [reportid, setGenerate] = useState<NeedData | any>('')
  console.log("reportid:", reportid)

  const navigate = useNavigate();


  const viewdonor = async () => {
    const fundid = assignData.orgID
    const rid = reportid.year
    const url = `/forgprinttranscript/${fundid}/${rid}`;

    console.log(url)
    // Use navigate to navigate to the URL
    navigate(url);
  }
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/orgfmreports.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };
  return (
    <div className="admin-layout-container">
      <div className="row">
        <div className="main-content">
          <div className="content-wrapper">
            <section className="app-page-header">
              <div>
                <h1 className="app-page-title">Organisation Reports</h1>
              </div>
              <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                Help for this Page
                <i className="pi pi-question-circle"></i>
              </a>
            </section>
            <Panel>
              <div className="grid">
                <div className="col-12">
                  <div className="card card-primary">
                    <div className="card flex flex-wrap justify-content-end my-2">
                      <span className="p-input-icon-left">
                        <i className="pi pi-search ml-2" />

                        <InputText
                          className="app-search-input"
                          value={globalFilter}
                          onChange={(e) => setGlobalFilter(e.target.value)}
                          placeholder="Global Search"
                        />
                      </span>
                    </div>
                    <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                      <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                      <Column field="nameoftheorg" sortable header="Organization"></Column>
                      <Column field="email" sortable header=" Email"></Column>
                      <Column field="mobile" sortable header="Phone No "></Column>

                      <Column header="Operation" body={(rowData) => (
                        <>
                          <div>
                            {/* <Button rounded outlined className='mr-1' severity="info" icon="pi pi-print" onClick={() => viewupload(rowData)} style={{ color: 'tomato' }} />      */}
                            <GFNButton rounded outlined icon="pi pi-print" onClick={() => viewupload(rowData)} buttonType="secondary" />
                          </div>
                        </>
                      )} />
                    </DataTable>
                  </div>
                </div>
              </div>
            </Panel>
            <Dialog header="Details" style={{ width: '35vw', height: 'auto' }} visible={acceptfield} onHide={cancelfield}>
              <div className="row">
                <div className="grid pt-3">
                  <div className="col-12">
                    <label htmlFor="name" className='font-bold'>Generate:</label>
                  </div>

                  <div className="col-12">
                    <Dropdown
                      className="w-full"
                      value={reportid}
                      onChange={(e: DropdownChangeEvent) => setGenerate(e.value)}
                      options={reportdata}
                      optionLabel="year"
                      placeholder="Select a Year"
                    />
                  </div>
                </div>
              </div>
              {/* <Button label="Close" onClick={cancelfield} className="mr-3 p-button-secondary" />
                                        <Button severity="info" label="Generate" rounded outlined className="mb-10" onClickCapture={() => viewfund()} style={{ float: 'right', backgroundColor: 'dodgerblue', color: 'white' }} /> */}
              <div className="flex justify-content-end gap-2 mt-4">
                <GFNButton label="Close" onClick={cancelfield} className="mr-3" buttonType='secondary' />
                <GFNButton label="Generate" rounded outlined onClickCapture={() => viewdonor()} buttonType="primary" />
              </div>
            </Dialog>
          </div>
        </div>
      </div>
    </div>
  )

}
export default FundOrganizationsReports;
